import React, { useEffect } from 'react'
import injectStyles from 'react-jss'
import CloseIcon from '@material-ui/icons/Close'
import { styles } from './styles'
import '@oppizi-ecosystem/meeting/dist/webcomponent'
import '@oppizi-ecosystem/meeting/dist/styles.css'
import { isProduction } from '../../../../Utils/Functions'

const BookingModal = ({ classes, isOpen, onClose, submitter, country }) => {
  const handleClose = () => {
    onClose()
  }
  useEffect(() => {
    if (!isOpen) return

    const handleMeetingClose = () => onClose()

    document.addEventListener('oppizi-meeting:close', handleMeetingClose)

    return () => {
      document.removeEventListener('oppizi-meeting:close', handleMeetingClose)
    }
  }, [onClose, isOpen])

  if (!isOpen) return null

  return (
    <div className={classes.modalOverlay} onClick={handleClose}>
      <div
        className={classes.modalContainer}
        onClick={e => e.stopPropagation()}
      >
        <div className={classes.closeButtonContainer}>
          <button className={classes.closeButton} onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </button>
        </div>
        <div className={classes.modalContent}>
          <oppizi-meeting
            first-name={submitter && submitter.firstName}
            last-name={submitter && submitter.lastName}
            email={submitter && submitter.email}
            country={country && country.code}
            is-prod={isProduction()}
            ui-mode="standalone"
            use-tabs
          />
        </div>
      </div>
    </div>
  )
}

export default injectStyles(styles)(BookingModal)
